import Module from "global/sparta-module-utility";
import spartaStickyUtility from "global/sparta-sticky-utility";
import spartaTemplates from "modules/global/title-module/3.2.0/js/templates";
import "css!modules/global/title-module/3.2.0/css/title-module.scss.css";










export default class titleModuleJS extends Module {
  constructor(options) {
    super(options);
  }

  init(args = {}) {
  }
}
